import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => (
  <footer className="footer">
    <div className="footer-grid container">
      <div>
        <div className="footer-brand-name">
          360 <span className="digi">Digi</span><span className="learning">Learning</span>
        </div>
        <p className="footer-brand-desc">
          Empowering engineers and architects with world-class cloud, programming, and system design education.
        </p>
      </div>
      <div className="footer-col">
        <div className="footer-col-title">Programs</div>
        <Link to="/programs">AWS Cloud</Link>
        <Link to="/programs">System Design</Link>
        <Link to="/programs">Programming</Link>
        <Link to="/programs">Architecture</Link>
      </div>
      <div className="footer-col">
        <div className="footer-col-title">Resources</div>
        <Link to="/practice-exam">Practice Exam</Link>
        <Link to="/training">1-on-1 Training</Link>
        <Link to="/request">Request Access</Link>
        <Link to="/login">Login</Link>
      </div>
      <div className="footer-col">
        <div className="footer-col-title">Legal</div>
        <Link to="#">Privacy Policy</Link>
        <Link to="#">Terms of Use</Link>
        <Link to="/request">Contact Us</Link>
      </div>
    </div>
    <div className="footer-bottom container">
      <p>© 2024 360DigiLearning. All rights reserved.</p>
    </div>
  </footer>
);

export default Footer;
